import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SUBSCRIPTION_CANCEL_FLOW_OPTIONS_API } from '../../constants/central-api';

export interface CancelFlowOption {
  type: string;
  title: string;
  description?: string;
  discounted_price?: number | string;
  original_price?: number | string;
  free_access_until?: string;
  [key: string]: unknown;
}

export interface CancelFlowOptionsData {
  subscription_id: number;
  current_price?: string | number;
  options?: Record<string, CancelFlowOption>;
}

export default async function get_cancel_flow_options_api_call(
  subscriptionId: number | string
): Promise<CancelFlowOptionsData | null> {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: SUBSCRIPTION_CANCEL_FLOW_OPTIONS_API(subscriptionId.toString()),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_SUBSCRIPTION_CANCEL_FLOW_OPTIONS';
  const customMsg = 'Cancel flow options retrieved successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;

  if (res?.actionType === actionType && response?.success === true) {
    if (response?.data) {
      return response.data as CancelFlowOptionsData;
    }
  }

  return null;
}
